import React from 'react'
import styled from 'styled-components'
import TypographyAtom from '../../atoms/typography/typography'
import { brandIvory, brandWhite } from '../../../assets/consts/color'
import Loader from '../../atoms/loader/Loader'

const Container = styled.div`
  padding: 16px;
  background-color: ${({ contrasted }) => (contrasted ? brandWhite : brandIvory)};

  & > p {
    font-size: 16px;
    text-align: center;
  }
`

function StockLabel({ value, inModal, isLoading }) {
  const getStockLabel = () => {
    if (value > 5) {
      return '5+ items in stock'
    }

    if (value <= 0) {
      return 'Out of stock'
    }

    return `${value} items in stock`
  }

  return (
    <Container contrasted={inModal} className="stock-label">
      {isLoading || value === 'pending' ? (
        <Loader />
      ) : (
        <TypographyAtom type="P" weight="Regular" copy={getStockLabel()} />
      )}
    </Container>
  )
}

export default StockLabel
